/**
 * moagem.js
 * Product page moagem UI sync.
 */

(function () {
  'use strict';

  window.MoagemConfig = window.MoagemConfig || {};

  function registerMoagemDefaults() {
    document.querySelectorAll('[data-moagem-block][data-moagem-default]').forEach((block) => {
      const suffix = block.dataset.templateSuffix || 'default';
      const defaultValue = block.dataset.moagemDefault;
      if (defaultValue) {
        window.MoagemConfig[suffix] = defaultValue;
      }
    });
  }

  function getMoagemDefaultForSuffix(suffix) {
    const key = suffix || 'default';
    return window.MoagemConfig[key] || window.MoagemConfig.default || null;
  }

  function syncQuickAddMoagemInputs(root = document) {
    root.querySelectorAll('product-form[data-moagem-template-suffix]').forEach((productForm) => {
      const suffix = productForm.dataset.moagemTemplateSuffix || 'default';
      const defaultValue = getMoagemDefaultForSuffix(suffix);
      if (!defaultValue) return;

      const moagemInput = productForm.querySelector('[name="properties[Moagem]"][data-moagem-default-input]');
      if (moagemInput) {
        moagemInput.value = defaultValue;
      }
    });
  }

  function initProductMoagem(container) {
    const selectEl = container.querySelector('.moagem-select');
    const buttons = container.querySelectorAll('.moagem-btn');

    if (!selectEl || !buttons.length) return;
    if (container.dataset.moagemInitialised) return;
    container.dataset.moagemInitialised = 'true';

    selectEl.addEventListener('change', (event) => {
      const value = event.target.value;
      buttons.forEach((btn) => {
        btn.classList.toggle('active', btn.getAttribute('data-value') === value);
      });
    });

    buttons.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        const value = btn.getAttribute('data-value');
        selectEl.value = value;
        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function initQuickAddMoagemPicker(container) {
    if (container.dataset.moagemPickerInitialised) return;
    container.dataset.moagemPickerInitialised = 'true';

    const toggle = container.querySelector('.quick-add__moagem-toggle');
    const optionsList = container.querySelector('.quick-add__moagem-options');
    const input = container.querySelector('input[name="properties[Moagem]"]');
    const valueEl = container.querySelector('.quick-add__moagem-value');
    const options = Array.from(container.querySelectorAll('.quick-add__moagem-option'));

    ['click', 'pointerdown', 'mousedown', 'touchstart'].forEach((eventName) => {
      container.addEventListener(eventName, (event) => {
        event.stopPropagation();
      });
    });

    if (!toggle || !optionsList || !input || !valueEl || !options.length) return;

    const close = () => {
      optionsList.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    };

    const open = () => {
      optionsList.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    };

    const setValue = (option) => {
      input.value = option.dataset.value || '';
      valueEl.textContent = option.textContent.trim();
      options.forEach((item) => {
        const isSelected = item === option;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });
      close();
      toggle.focus();
    };

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      optionsList.hidden ? open() : close();
    });

    options.forEach((option) => {
      option.addEventListener('click', () => setValue(option));
      option.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setValue(option);
        }
      });
    });

    container.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });

    document.addEventListener('click', (event) => {
      if (!container.contains(event.target)) close();
    });
  }

  function initAllProductMoagem() {
    document.querySelectorAll('[data-moagem-block]').forEach(initProductMoagem);
    document.querySelectorAll('.quick-add__moagem').forEach(initQuickAddMoagemPicker);
  }

  function initMoagem() {
    registerMoagemDefaults();
    initAllProductMoagem();
    syncQuickAddMoagemInputs();
  }

  document.addEventListener('DOMContentLoaded', () => {
    initMoagem();

    const observer = new MutationObserver(() => {
      initMoagem();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
